import { render, staticRenderFns } from "./SmTableRepairPlanUpdateDetails.vue?vue&type=template&id=8bff359a&scoped=true&"
import script from "./SmTableRepairPlanUpdateDetails.vue?vue&type=script&lang=ts&"
export * from "./SmTableRepairPlanUpdateDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableRepairPlanUpdateDetails.vue?vue&type=style&index=0&id=8bff359a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bff359a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
